<template>
  <div class="p-0 md:p-2 flex flex-col items-center justify-start min-h-[75vh]">
    <div class="container max-w-screen-lg mx-auto">
      <div>

        <div class="bg-white rounded shadow-lg p-4 px-4 md:p-8 mb-6">
          <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
            
            <div class="text-left block mb-4">
              <p class="mb-2 font-medium text-lg text-gray-900">
                {{ descriptionTitle }}
              </p>
              <p class="text-gray-500">
                Campos com <span class="text-red-500">*</span> são obrigatórios
              </p>
            </div>

            <div id="form-fields" class="lg:col-span-2">
              <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5">

                <!-- nome -->
                <div class="md:col-span-3">
                  <BaseInput
                    type="text"
                    name="form.realizado_em"
                    v-model="store.formDoctor.nome"
                    label="Nome do profisisonal"
                    :info="'Nome'"
                    :required-field="true"
                    :activeDefault="false"
                  >
                    <template #append>
                      <CleanInputButton
                        @click="store.formDoctor.nome = null"
                      />
                    </template>
                  </BaseInput>

                  <span
                    name="formDoctor.nome"
                    class="text-red-600 text-sm"
                  />
                </div>

                <!-- cargo -->
                <div class="md:col-span-2">
                  <BaseInput
                    type="text"
                    name="formDoctor.especialidade"
                    v-model="store.formDoctor.especialidade"
                    label="Especialidade"
                    :info="'Cargo'"
                    :required-field="true"
                    :activeDefault="false"
                  >
                    <template #append>
                      <CleanInputButton
                        @click="store.formDoctor.especialidade = null"
                      />
                    </template>
                  </BaseInput>

                  <span
                    name="formDoctor.especialidade"
                    class="text-red-600 text-sm"
                  />
                </div>

                <!-- cidade -->
                <div class="md:col-span-2">
                  <div class="md:col-span-2 mt-1.5">
                    <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
                      Informe uma cidade/estado <a class="text-red-600 ml-1">*</a>
                    </label>
                    <div
                      class="h-10 flex rounded items-center"
                    >
                      <SimpleSelect
                        class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                        :data="cidades"
                        @selected-data="(val) => (store.formDoctor.cidade_id = val.value)"
                      />
                    </div>
                  </div>

                  <span
                    name="formDoctor.cidade_id"
                    class="text-red-600 text-sm"
                  />
                </div>

              </div>
            </div>
          </div>
          <div class="flex justify-center mt-8">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import CleanInputButton from '../utils/CleanInputButton.vue';
import BaseInput from '@/components/Inputs/BaseInput.vue';
import { dataAso } from '../store'
import { docType } from '../lookups/form';
import { 
  PhCloudArrowUp,
  PhFileArrowUp
} from '@phosphor-icons/vue';

export default({
  components: {
    SimpleSelect,
    CleanInputButton,
    BaseInput,
  },
  props: {
    descriptionTitle: String,
  },
  data () {
    return {
      PhFileArrowUp,
      PhCloudArrowUp,
      selectedFileName: undefined,
      selectedFileUrl: undefined,
      store: dataAso.state,
      dataAso,
      docType,
    }
  },
  computed: {
    cidades() {
      return this.dataAso.getters.getCities.map(item => ({
        value: item.id,
        name: item.nome
      }));
    },
  }
})
</script>
